import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import moment from 'moment';
import App from './app';
import reportWebVitals from './reportWebVitals';
import Provider from 'context/Provider';
import DataProvider from 'context/DataProvider';
import 'styles/global.css';
import 'moment/locale/id';
import { initializeSignOzTracing } from '@echoteam/signoz-react';

initializeSignOzTracing();

moment.locale('id');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider>
        <DataProvider>
          <App />
        </DataProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
